import { type Common } from './common.js';
import {
  type CleanupArgs,
  type CleanupResponse,
  type CompleteCallbackArgs,
  type CompleteCallbackResponse,
  type InitiateConnectCardArgs,
  type InitiateConnectCardResponse,
} from './models/fivetranConnector.js';

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/fivetran/connect-card';

  constructor(common: Common) {
    this.common = common;
  }

  /**
   * Initiate the Fivetran Connect Card OAuth flow.
   * Returns a Connect Card URL to open in a popup/window and callbackData to pass to completeCallback().
   */
  async initiateConnectCard(args: InitiateConnectCardArgs): Promise<InitiateConnectCardResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, args);
  }

  /**
   * Complete OAuth callback after Connect Card succeeds.
   * Creates Notable connection if setup_state is 'connected', otherwise deletes Fivetran connection.
   */
  async completeCallback(args: CompleteCallbackArgs): Promise<CompleteCallbackResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/callback`);
    return await this.common.postJSON(url, args);
  }

  /**
   * Delete abandoned Fivetran connection.
   * Requires organizationId to verify ownership before deletion.
   */
  async cleanup(args: CleanupArgs): Promise<CleanupResponse> {
    const { fivetranConnectionId, organizationId } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/cleanup/${fivetranConnectionId}`, {
      organizationId,
    });
    const response = await this.common.deleteJSON(url);
    return response ?? { ok: true };
  }
}
